/** Copy when public profile `can_message` is false (campaign gate modal). */
export const CREATOR_MESSAGE_REQUIRES_CAMPAIGN =
    'You do not currently have an active campaign, create a campaign to message this creator.';

/** Returns false when the API explicitly forbids messaging this creator. */
export function canMessageCreator(canMessage?: boolean | null): boolean {
    return canMessage !== false;
}
